import React from 'react';
import Link from 'next/link';

const MenuIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
  </svg>;


const CartIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
  </svg>;


const navLinks = [
{ label: 'Home', href: '/' },
{ label: 'Inkjet Printers', href: '/inkjet-printers/' },
{ label: 'Home Printers', href: '/home-printers/' },
{ label: 'Office Printers', href: '/office-printers/' },
{ label: 'Guides', href: '/guides/' },
{ label: 'About', href: '/about/' },
{ label: 'Contact Us', href: '/contact/' }];


export default function Navbar() {
  return (
    <div className="sticky top-0 z-50 bg-[linear-gradient(120deg,#edf5ff_0%,#ffffff_42%,#ffe7eb_100%)] text-slate-950 shadow-[0_10px_30px_rgba(15,23,42,0.08)]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_50%,rgba(20,60,103,0.16),transparent_30%),radial-gradient(circle_at_82%_50%,rgba(180,35,53,0.16),transparent_30%)]" />
      <div className="relative container">
        <div className="flex min-h-[5.75rem] items-center gap-4 py-4 lg:gap-5">
          {/* Logo */}
          <div className="flex min-w-0 shrink-0 items-center">
            <Link href="/" className="flex items-center shrink-0 gap-2.5" aria-label="RePrint Solution home">
              {/* Icon mark */}
              <div className="flex h-10 w-10 items-center justify-center rounded-[10px] bg-[#143c67] shadow-md sm:h-11 sm:w-11">
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-7 sm:w-7">
                  {/* Printer body */}
                  <rect x="6" y="14" width="28" height="16" rx="3" fill="#ffffff" opacity="0.15"/>
                  <rect x="6" y="14" width="28" height="16" rx="3" stroke="#ffffff" strokeWidth="2"/>
                  {/* Paper tray top */}
                  <rect x="11" y="8" width="18" height="8" rx="2" fill="#b42335"/>
                  {/* Paper output */}
                  <rect x="11" y="26" width="18" height="8" rx="2" fill="#b42335"/>
                  {/* Printer light dot */}
                  <circle cx="29" cy="22" r="2" fill="#b42335"/>
                </svg>
              </div>
              {/* Brand text */}
              <div className="flex flex-col leading-none">
                <span className="text-[17px] font-extrabold tracking-tight text-[#143c67] sm:text-[19px]">
                  Re<span className="text-[#b42335]">Print</span>
                </span>
                <span className="text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500 sm:text-[11px]">
                  Solution
                </span>
              </div>
            </Link>
          </div>

          {/* Desktop Nav */}
          <div className="hidden flex-1 items-center justify-center lg:flex">
            <ul className="flex rounded-[10px] bg-[#b42335] px-2 py-1.5 shadow-[0_14px_36px_rgba(127,29,29,0.22)] ring-1 ring-[#123a63]/10">
              {navLinks?.map((link) =>
              <li key={link?.href} className="relative">
                  <Link
                  href={link?.href}
                  className="flex h-11 items-center self-center rounded-[8px] px-5 text-sm font-semibold text-white transition hover:bg-white/20 focus-visible:bg-white/20 lg:text-[15px] xl:px-7">
                  
                    {link?.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Right side */}
          <div className="ml-auto flex shrink-0 items-center justify-end gap-3">
            {/* Mobile menu */}
            <details className="group relative lg:hidden">
              <summary className="flex cursor-pointer list-none items-center justify-center rounded-[8px] border border-[#c8263f]/25 p-2.5 text-slate-800 transition hover:bg-[#fff1f3] hover:text-[#b42335] focus-visible:outline-0">
                <span className="sr-only">Open main menu</span>
                <span className="block h-5 w-5">
                  <span className="block h-0.5 w-5 bg-current" />
                  <span className="mt-1.5 block h-0.5 w-5 bg-current" />
                  <span className="mt-1.5 block h-0.5 w-5 bg-current" />
                </span>
              </summary>
              <div className="absolute top-12 right-0 z-50 w-64 rounded-[10px] border border-[#c8263f]/20 bg-white p-3 text-slate-950 shadow-xl">
                <nav className="grid gap-1">
                  {navLinks?.map((link) =>
                  <Link
                    key={link?.href}
                    href={link?.href}
                    className="rounded-[8px] px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-[#fff1f3] hover:text-[#b42335]">
                    
                      {link?.label}
                    </Link>
                  )}
                </nav>
              </div>
            </details>

            {/* Get A Quote */}
            <Link
              href="/contact"
              className="hidden h-12 items-center justify-center rounded-[8px] border-2 border-[#c8263f] bg-white px-6 text-sm font-semibold text-slate-950 transition hover:bg-[#c8263f] hover:text-white sm:inline-flex">
              
              Get A Quote
            </Link>

            {/* Cart */}
            <Link
              href="/cart"
              className="relative flex h-12 w-12 items-center justify-center rounded-[8px] border-2 border-[#143c67] text-[#143c67] transition hover:border-[#c8263f] hover:bg-[#fff1f3] hover:text-[#b42335] focus-visible:outline-0"
              aria-label="View cart">
              
              <CartIcon />
            </Link>
          </div>
        </div>
      </div>
    </div>);

}